<template>
    <a class="link">
        <img :src="localLink.icon">
        <span  v-html="localLink.name"></span>

        <v-menu top left>
            <template v-slot:activator="{ on }">
                <div style="bottom:12px; position: absolute; right: 12px">
                    <v-btn class="link-context-menu" @click="$emit('move_block_left')"  icon  >
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-btn class="link-context-menu" @click="$emit('move_block_right')"  icon  >
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </div>

            </template>
            <v-list>

                <v-list-item @click="$emit('copy_block')">
                    <v-list-item-title>Копировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="editor = true">
                    <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('delete-link')">
                    <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-dialog v-model="editor" max-width="600px">
            <link-editor v-if="editor" @close-adder="editor = false" :link="localLink" @update-link="localLink = $event"></link-editor>
        </v-dialog>


    </a>
</template>

<script>
    import LinkEditor from "./LinksBlockLinkEditor";


    export default {
        name: "LinksBlockLink",
        components:{LinkEditor},
        props:["link"],
        data(){
            return{
                localLink: this.link,
                editor: false,
            }
        },
        watch:{
            localLink: {
                deep: true,
                handler(){
                    console.log("kek")
                    this.$emit("update-link", this.localLink)
                }
            }
        },
        methods:{
            updateLink(){
                this.$emit("update-link", this.localLink)
            }
        }
    }
</script>

<style scoped>

    .link{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .link img{
        width: 100px;
        min-height: 100px;
        margin-bottom: 25px;


    }

    .link span{
        margin-bottom: 25px;
        margin-top: 12px;
        font-size: 32px;
        line-height: 1.17;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
        text-align: center;
    }

    .link-context-menu{
        opacity: 0;
        transition: 0.2s;
    }

    .link:hover .link-context-menu{
        opacity: 1;
    }

</style>